/**
 * Resize handling.
 * Sets and maintains window.iTheWidth / window.iTheHeight globals,
 * handles layout adjustments on resize: header offset, nav padding,
 * sticky table cells, and adsanity ad aspect ratios.
 */

function doResize() {
  window.iTheWidth  = Math.max(document.documentElement.clientWidth,  window.innerWidth  || 0);
  window.iTheHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

  if ($('.header-offset').length > 0) {
    $('.header-offset').css({ 'margin-top': $('header.site-header').outerHeight() + 'px' });
  }

  $('nav.site-navigation').css({ 'padding-top': $('header.site-header').outerHeight() + 'px' });

  if ($('.-is-sticky').length > 0) {
    const iTheCellW = $('.-is-sticky.-is-first').outerWidth();
    $('.-is-sticky.-is-first')
      .attr('data-width', iTheCellW * 1.1)
      .css({ width: (iTheCellW * 1.1) + 'px' });
  }
}

function initAdsanity() {
  if ($('.wordpress-content-container').find('.adsanity-inner').length === 0) return;

  $('.wordpress-content-container').find('.adsanity-inner').each(function() {
    const w = $(this).find('img').attr('width')  * 1;
    const h = $(this).find('img').attr('height') * 1;
    let iThePerc = 100;

    if      (w > h) iThePerc = (w * 100) / h;
    else if (h > w) iThePerc = (h * 100) / w;

    $(this).css({ 'padding-bottom': iThePerc + '%' });
    $('<span class="ad-label d-block">ANNONSE</span>').insertBefore($(this));
  });
}

export function initResize() {
  // Seed globals before first resize
  window.iTheWidth  = Math.max(document.documentElement.clientWidth,  window.innerWidth  || 0);
  window.iTheHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  window.doResize   = doResize;

  window.addEventListener('resize', () => doResize());

  initAdsanity();
}



// WEBPACK FOOTER //
// ./scripts/routes/common/resize.js